import React from 'react'
import PropTypes from 'prop-types'

import { StyledBlock } from './BlockMixMediaIframe.styled'
import NormalizeMedia from '../../utils/NormalizeMedia'
import useMediaQuery from '../../hooks/useMediaQuery'
import { deviceMax } from '../../theme/breakpoints'

const BlockMixMediaIframe = ({ className, media }) => {
  const isMobile = useMediaQuery(deviceMax.mobileL)

  if (media.sys.contentType.sys.id === 'contentMedia') {
    return (
      <StyledBlock className={className}>
        {NormalizeMedia(media, isMobile, false)}
      </StyledBlock>
    )
  }

  if (media.sys.contentType.sys.id === 'contentIframe')
    return (
        <StyledBlock className={className}>
          <iframe src={`${media.iframeUrl}`}
                  allow='microphone; accelerometer; gyroscope; vr; fullscreen; xr-spatial-tracking' />
        </StyledBlock>
      )
}

BlockMixMediaIframe.propTypes = {
  className: PropTypes.string,
  media: PropTypes.object.isRequired,
}

export default BlockMixMediaIframe